import "./simple-date.scss";
import moment from "moment";

window.app.directive("simpleDate", [
  function() {
    return {
      restrict: "E",
      scope: {
        ngModel: "=",
        disabled: "@"
      },
      template: (tElement, tAttrs) => {
        tElement.html(require("./simple-date.html"));
        tElement.addClass("material simple-datepicker move-label");
      },
      controller: [
        "$scope",
        "$element",
        "$state",
        function(scope, $element, $state) {
          scope.months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ].map((name, i) => ({ num: i, name }));
          const curYear = new Date().getFullYear();
          scope.years = Array.from(Array(10)).map((v, i) => curYear + i);
          var value = moment(scope.ngModel || Date.now())
            .hour(0)
            .minute(0)
            .second(0)
            .millisecond(0);
          function update() {
            // scope.year = value.year();
            // scope.month = value.month();
            // scope.day = value.date();
            // TODO support both native date as well as previous select-based
            scope.dateObj = new Date(value);
          }
          update();

          scope.onChange = () => {
            value.set(moment(scope.dateObj).toObject());
            // value
            //   .year(scope.year)
            //   .month(scope.month)
            //   .date(scope.day);
            update();
            scope.ngModel = value.valueOf();
          };
        }
      ]
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/simple-date/simple-date.js